/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LicensePlateData } from './licensePlateData';
import { VehicleUsage } from './vehicleUsage';
import { NewPrice } from './newPrice';
import { VehicleOwner } from './vehicleOwner';
import { Driver } from './driver';
import { PurchasePrice } from './purchasePrice';
import { SpecialEquipment } from './specialEquipment';
import { ConstructionKind } from './constructionKind';
import { OwnershipRelationship } from './ownershipRelationship';

/**
 * (german: Pkw)   (bipro-fahrzeug::PKW)
 */
export interface Car {
  /**
   * Technical discriminator for the concrete vehicle type..
   */
  insuredObjectType: string;
  /**
   * Unique identification of the insured object within the scope of the request/response object.   Every insured object must define an insuredObjectId.   Values can be choosen freely, but must be unique in the request/response object.   Example: *CAR01*
   */
  insuredObjectId: string;
  /**
   * Date of initial registration of the vehicle.   (german: Erstzulassung)
   */
  initialRegistration?: string;
  ownershipRelationship?: OwnershipRelationship;
  /**
   * Vehicle identification number.
   */
  identificationNumber?: string;
  /**
   * HSN number for car manufacturer, e.g. 0603 for VW.
   */
  HSN?: string;
  /**
   * TSN for car model, e.g. CDY for Golf TSI.
   */
  TSN?: string;
  /**
   * (german: Baujahr)   (bipro-fahrzeug::Baujahr)
   */
  manufacturingYear?: string;
  /**
   * (german: Anzahl der Vorbesitzer)   (bipro-fahrzeug::AnzahlDerVorbesitzer)
   */
  numberOfPreviousOwners?: number;
  /**
   * (german: Sonderausstattung)   (bipro-fahrzeug::Sonnderausstattung)
   */
  specialEquipments?: Array<SpecialEquipment>;
  usage?: VehicleUsage;
  licensePlateData?: LicensePlateData;
  purchasePrice?: PurchasePrice;
  newPrice?: NewPrice;
  /**
   * (german: Kilometerstand)
   */
  mileage?: number;
  constructionKind?: ConstructionKind;
  vehicleOwner?: VehicleOwner;
  /**
   * List of vehicle drivers.   (bipro-fahrzeug::Fahrer)
   */
  drivers?: Array<Driver>;
}
export namespace Car {}
